import { Component, OnInit } from '@angular/core';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { AzimuthToolService } from 'src/app/map/services/azimuth-tool.service'
import { TabsComponent } from '../tabs/tabs.component';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-azimuth-tool',
  templateUrl: './azimuth-tool.component.html',
  styleUrls: ['./azimuth-tool.component.scss'],
  standalone: false
})
export class AzimuthToolComponent implements OnInit {

  constructor(
    public azimuthToolController : AzimuthToolService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService
  ) { }

  ngOnInit(): void {


  }

  cancelWindow():void{
    this.azimuthToolController.active = !this.azimuthToolController.active;
    this.toolsService.navigationOnTop = false;

    this.azimuthToolController.clearListeners();
  }

}
